import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useCurrentPath } from '@service-initiation/shared-data-access-flow-manager';
import { formatPhoneNumberWithDashes } from '@service-initiation/shared-utils-helpers';
import { TranslationEntries } from '@service-initiation/tech-care-data-access-i18n';
import { Route } from '@service-initiation/tech-care-data-access-routing';
import {
  type CustomerDetails,
  useCustomerDetailsConfirmedAtom,
  useCustomerDetailsValue,
} from '@service-initiation/tech-care-data-access-store';

import {
  PrimaryText,
  SecondaryText,
  VisitDetailsListItem,
} from '../components';

const TEXT = TranslationEntries.Repairs.Cart.VisitDetails;

const importantDetailsSelected = (details: CustomerDetails | undefined) => {
  if (!details) {
    return false;
  }
  return details.email ||
    details.firstName ||
    details.lastName ||
    details.phoneNumber
    ? true
    : false;
};

export const CustomerDetailsSummaryItem: FC = () => {
  const { t } = useTranslation();
  const currentPath = useCurrentPath();
  const customerDetails = useCustomerDetailsValue();
  const [customerDetailsConfirmed] = useCustomerDetailsConfirmedAtom();

  return (
    <VisitDetailsListItem
      active={
        currentPath === Route.CustomerDetails ||
        importantDetailsSelected(customerDetails)
      }
      iconSrc="chat-bubble-circle"
      linkTo={
        currentPath === Route.BillingDetails ? 'CustomerDetails' : undefined
      }
      title={t(TEXT.ContactDetailsText)}
    >
      {customerDetailsConfirmed &&
        customerDetails &&
        importantDetailsSelected(customerDetails) && (
          <PrimaryText className="fs-mask">
            {`${customerDetails.firstName} ${customerDetails.lastName}`}
            <SecondaryText>
              <br />
              {customerDetails.email}
              <br />
              {formatPhoneNumberWithDashes(customerDetails.phoneNumber)}
            </SecondaryText>
          </PrimaryText>
        )}
    </VisitDetailsListItem>
  );
};
